import {
  InsufficientAccessBackground,
  StyledActivityCardBackground,
  TeamDetailSection,
  TeamHeaderSection,
  useAccessState
} from 'modules';
import React from 'react';
import {
  Outlet,
  useParams
} from 'react-router-dom';



export type TeamActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const TeamActivity = (props: TeamActivityProps) => {
  const params = useParams();
  const access = useAccessState('Membership');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }
  if (params.personId) {
    return <Outlet />;
  }

  return (
    <StyledActivityCardBackground.FC>
      <TeamHeaderSection.FC />
      <TeamDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
